import { useEffect } from 'react';

import { PermissionType } from 'api/types/entity';
import { FormFooter, FormFooterCancel } from 'components';
import { useFormPrompt } from 'hooks';
import { useTranslation } from 'libs/i18n';
import { PermissionWrapper } from 'libs/permissions';
import {
  Submit,
  useFormContext,
} from 'modules/operation/common/forms/operationForm';

import { useOperationContext } from '../../providers/OperationProvider';

export interface OperationFormFooterProps {
  submitLoading: boolean | undefined;
}

export const OperationFormFooter = ({
  submitLoading,
}: OperationFormFooterProps) => {
  const { t } = useTranslation();

  const { confirmIsChanged } = useFormPrompt();
  const { onDisableEdit } = useOperationContext();

  const { readOnly, submitDisabled, dirty, setReadOnly, resetForm } =
    useFormContext();

  const editable = !readOnly;

  const disableEditable = () => {
    confirmIsChanged(() => onDisableEdit(() => setReadOnly(true)));
  };

  useEffect(() => {
    if (!editable) {
      resetForm();
    }
  }, [editable, resetForm]);

  return (
    <FormFooter visible={!readOnly}>
      <FormFooterCancel onClick={disableEditable} />
      <PermissionWrapper permissions={[PermissionType.Operation_UpdateOne]}>
        <Submit
          disabled={submitDisabled || !dirty}
          label={t('common.save')}
          loading={submitLoading}
          sizeVariant="m"
        />
      </PermissionWrapper>
    </FormFooter>
  );
};
